export default "__VITE_ASSET__Cmi79w35__"